import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TRANSFORM_BEFORE, TRANSFORM_AFTER } from './salesData';
export function TransformationSection() {
  return <section id="transformacion" className="bg-white py-12 sm:py-16" data-id="element-236" data-mp="31uw5grvc94zh">
      <div className="mx-auto max-w-4xl px-5" data-id="element-237" data-mp="2ww2r6x8899y9">
        <h2 className="mx-auto max-w-[24ch] text-center font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-238" data-mp="2rysztc1a2o7s">
          El problema no es la dieta. <span className="mark-yellow" data-id="element-239" data-mp="2j5peyioaz934">Es no saber qué cocinar.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[46ch] text-center font-sans text-[0.92rem] leading-relaxed text-taupe sm:max-w-[56ch] sm:text-[1rem]" data-id="element-240" data-mp="2e75w4r50adez">
          Encontrar recetas que sean Keto y Sin Gluten al mismo tiempo, con ingredientes fáciles de
          conseguir, es una búsqueda eterna. Así se abandona cualquier alimentación.
        </p>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-241" data-mp="208oacyynvazp">
          <div className="rounded-2xl bg-cream p-5" data-id="element-242" data-mp="fbcauy9ca8lg">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-243" data-mp="f9hr3n9t0miy">
              Hoy
            </p>
            <ul className="mt-3.5 space-y-2.5" data-id="element-244" data-mp="5cwlp0tvh9el">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] leading-snug text-taupe" data-id="element-245" data-mp="abzf1o0hpr6q">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-246" data-mp="y23jfxli5uys" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-gold bg-white p-5 shadow-[0_20px_44px_-30px_rgba(140,100,4,0.7)]" data-id="element-247" data-mp="t1fnqymbwpy8">
            <p className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-248" data-mp="39ptb10kllgg3">
              Con las 500+ recetas
            </p>
            <ul className="mt-3.5 space-y-2.5" data-id="element-249" data-mp="1ka8wzcsy2mj6">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] font-semibold leading-snug text-charcoal" data-id="element-250" data-mp="1famh0vlqes6o">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-251" data-mp="15lcpphyppdjm" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-center font-display text-[0.7rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-252" data-mp="rlbrybdqum8d">
          Eliges · Cocinas · Comes rico · Sostienes
        </p>
      </div>
    </section>;
}